
const MN_LINKS = {
    MN_NEW_CUSTOMERS: 'https://www.mnsure.org/new-customers/apply/index.jsp',
    MN_REPORT_CHANGE: 'https://www.mnsure.org/current-customers/manage-account/report-change/private.jsp',
    MN_CONTACT_US: 'https://www.mnsure.org/help/contact-us/index.jsp',
    MN_DOCUMENTS: 'https://www.mnsure.org/documents/index.jsp',
    MN_MY_ELIGIBILITY_HOME: '${MANAGE_ASSISTER}/CitizenPortal/application.do?CitizenAccountHome',
};

const CA_LINKS = {
    CA_ELIGIBILITY: 'https://${CALHEERS_URL}/static/lw-web/eligibility?householdCaseId=${householdCaseId}',
    CA_ACCOUNT_HOME: 'https://${CALHEERS_URL}/static/lw-web/account-home?householdCaseId=${householdCaseId}',
    CA_APPEAL_INFORMATION: 'https://www.coveredca.com/members/file-an-appeal-or-complaint/',
    CA_TOOLKIT: 'https://hbex.coveredca.com/toolkit/',
    BROKER_SELF_DELEGATION_TOOL: '${selfDelegationSwitchAccUrl}?recordId=${encryptedBrokerAssisterId}&recordType=2&lang=${lang}',
    ASSISTER_SELF_DELEGATION_TOOL: '${selfDelegationSwitchAccUrl}?recordId=${encryptedBrokerAssisterId}&recordType=3&lang=${lang}',
    CA_START_NEW_APP: '${switchAccUrl}&_pageLabel=individualHomePage&ahbxId=&ahbxUserType=1&recordId=${encryptedBrokerAssisterId}&recordType=2&newAppInd=Y&lang=${lang}',
    CA_BACK_TO_ADMIN_SEARCH: 'https://${CALHEERS_URL}/apspahbx/ahbxadmin.portal?_nfpb=true&_st=&_nfls=false&_pageLabel=administrationHomePage#'
};

const ID_LINKS = {
    DOWNLOAD_APPEALS_FORM: 'https://www.yourhealthidaho.org/filing-an-appeal/',
    DEFAULT_SURVEY_LINK: 'https://www.surveymonkey.com/r/XHHPYRD',
    ROLE_BASED_LINK: 'https://www.surveymonkey.com/r/9L9VDM8'
};


const NV_LINKS = {
    USER_GUIDES: 'https://www.nevadahealthlink.com/user-guides/',
    ESTATE_RECOVERY: 'https://www.medicaid.gov/',
    IMMIGRATION_STATUS_LINK: 'https://help.nevadahealthlink.com/hc/en-us/articles/360028568792',
    RECONCILE_APTC: 'https://help.nevadahealthlink.com/hc/en-us/articles/360028568612-How-to-reconcile-your-premium-tax-credit'
};

const NJ_LINKS = {
    ESTATE_RECOVERY: 'https://www.state.nj.us/humanservices/dmahs/clients/The_NJ_Medicaid_Program_and_Estate_Recovery_What_You_Should_Know.pdf',
    GET_COVERED: 'https://www.getcovered.nj.gov',
    FAMILY_CARE: 'http://www.NJFamilyCare.org',
    HELP_LINK_ES: 'https://nj.gov/getcoverednj/espanol/findanswers/faqs',
    HELP_LINK_EN: 'https://nj.gov/getcoverednj/findanswers/faqs',
    EXCEPTIONAL_CIRCUMSTANCES_ATTESTATION_FORM: 'https://nj.gov/getcoverednj/getstarted/buy/sepexcepcirattestation.pdf'
};

const PA_LINKS = {
    CONNECT: 'https://pennie.com/connect/',
    FAQ: 'https://pennie.com/learn/faqs/',
    VOTER_REGISTRATION: 'https://pennie.com/voterregistration/',
    ORGAN_DONOR_REGISTRATION: 'https://pennie.com/organdonor/'
};

const IL_LINKS = {
    CONNECT: 'https://getcovered.illinois.gov/connect/',
    FAQ: 'https://getcovered.illinois.gov/learn/faqs/',
    VOTER_REGISTRATION: 'https://getcovered.illinois.gov/voterregistration/',
    ORGAN_DONOR_REGISTRATION: 'https://getcovered.illinois.gov/organdonor/'
};

const GA_LINKS = {
    AGENTS_LINK: 'https://georgiaaccess.gov/for-partners/agents/',
    ESTATE_RECOVERY: 'https://medicaid.georgia.gov/programs/third-party-liability/medicaid-estate-recovery',
};

const NM_LINKS = {
    BEWELL_APPT: 'https://bewellnm.com/appointment'
};

const GENERAL = {
    HEALTH_CARE_GOV: 'https://www.healthcare.gov/',
    DEFAULT_SURVEY_LINK: 'https://www.surveymonkey.com/r/57CVPF3',
    USPS_GENERAL_DELIVERY: 'https://faq.usps.com/s/article/What-is-General-Delivery',
    HEALTH_CARE_GOV_REPORTING_DEDUCTIONS: {
        en: 'https://www.healthcare.gov/reporting-deductions/',
        es: 'https://www.cuidadodesalud.gov/es/reporting-deductions/'
    }
};
export const CHIP_ELIGIBLE_LINKS = {
    MN: 'https://mn.gov/dhs/people-we-serve/adults/health-care/health-care-programs/'
};
export const MEDICAID_ELIGIBLE_LINKS = {
    ID: 'https://idalink.idaho.gov/',
    MN: 'https://mn.gov/dhs/people-we-serve/adults/health-care/health-care-programs/',
    GA: 'https://gateway.ga.gov/access/',
    NV: 'https://www.google.com/'
};

export const MEDICARE_ELIGIBLE_LINKS = {
    GA: 'https://www.medicare.gov/',
    ID: 'https://doi.idaho.gov/shiba/',
    MN: 'http://www.seniorlinkageline.com',
    NJ: 'https://www.medicare.gov/',
    NV: 'https://help.nevadahealthlink.com/hc/en-us/articles/360028558952-Medicare',
    PA: 'https://help.pennie.com/hc/en-us/articles/360049727073-Medicare'
};

export const HOTLINE = {
    GA: 'tel:877-423-4746',
    MN: 'tel:877-423-4746'
};

export const PAGE_TITLE = {
    GA: 'Compare Health Insurance Plans and Prices - Georgia Access',

};


export default {
    CA_LINKS,
    GENERAL,
    ID_LINKS,
    IL_LINKS,
    MN_LINKS,
    NJ_LINKS,
    NM_LINKS,
    NV_LINKS,
    PA_LINKS,
    GA_LINKS
};
